import React, { useState } from 'react';
import { usePanelConfig } from '../../../../modules/panel';

/**
 * OutputTypeForm - Çıkış tipi ekleme/düzenleme formu
 */
export default function OutputTypeForm({ outputType, onDone }) {
  const isEditing = !!outputType;
  const { outputCategories, addOutputType, updateOutputType } = usePanelConfig();

  const [form, setForm] = useState({
    id: outputType?.id || '',
    categoryId: outputType?.categoryId || 'PRIZE',
    code: outputType?.code || '',
    label: outputType?.label || '',
    defaultPower: outputType?.defaultPower || 0,
  });

  const categoriesList = Object.values(outputCategories).sort(
    (a, b) => a.order - b.order
  );

  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = () => {
    const selectedCat = outputCategories[form.categoryId];
    const data = {
      ...form,
      id: form.id || `${selectedCat.prefix}_${form.code.toUpperCase()}`,
      defaultPower: Number(form.defaultPower),
    };

    if (isEditing) {
      updateOutputType(data);
    } else {
      addOutputType(data);
    }
    onDone();
  };

  return (
    <div>
      <div className="group-header">
        {isEditing ? `Düzenle: ${outputType.label}` : 'Yeni Çıkış Tipi'}
      </div>

      <div className="form-group">
        <label>Kategori</label>
        <select
          value={form.categoryId}
          onChange={e => handleChange('categoryId', e.target.value)}
          disabled={isEditing}
        >
          {categoriesList.map(cat => (
            <option key={cat.id} value={cat.id}>{cat.label}</option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label>Kod</label>
        <input
          type="text"
          value={form.code}
          onChange={e => handleChange('code', e.target.value)}
          disabled={isEditing}
          placeholder="Ör: NORMAL"
        />
      </div>

      <div className="form-group">
        <label>Ad</label>
        <input
          type="text"
          value={form.label}
          onChange={e => handleChange('label', e.target.value)}
          placeholder="Ör: Normal Priz"
        />
      </div>

      <div className="form-group">
        <label>Varsayılan Güç (W)</label>
        <input
          type="number"
          value={form.defaultPower}
          onChange={e => handleChange('defaultPower', e.target.value)}
          min="0"
        />
      </div>

      <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
        <button className="settings-btn" onClick={onDone}>
          İptal
        </button>
        <button className="settings-btn settings-btn-primary" onClick={handleSubmit}>
          {isEditing ? 'Güncelle' : 'Ekle'}
        </button>
      </div>
    </div>
  );
}
